var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, css, html, LitElement, property } from 'lit-element';
import i18n from 'roddeh-i18n';
import '@tauceti/web-components-loader/dist/loader-ring';
import { formatPrice } from '../helpers/prices';
import Cart from '../services/cart';
let ProductModal = class ProductModal extends LitElement {
    constructor() {
        super(...arguments);
        this.sku = '';
        this.productID = '0';
        this.product = null;
        this.loading = true;
        this.currency = '';
        this.prodAsGiftButtonText = '';
        this.showProdAsGiftButton = false;
        this.decimalDigits = 2;
        this.altshopID = '1';
        this.fromCart = false;
    }
    static get styles() {
        return css `
            .loading-container {
                padding: 0.5em 3em 0.5em 2em;
            }
            .loading-container loader-ring {
                margin-right: 0.5em;
            }

            .product-box {
                margin-top: 2rem;
                display: flex;
            }

            @media (max-width: 600px) {
                .product-box {
                    flex-direction: column;
                }
            }

            .product-box-left,
            .product-box-right {
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
            }

            .product-box-right {
                position: relative;
            }

            .product-box-left h2 {
                margin: 0;
                font-weight: 600;
                position: relative;
                padding-top: 0.2em;
            }
            .product-box-left h2::after {
                content: '';
                position: absolute;
                display: block;
                border-top: 6px solid var(--color-primary);
                top: -0.27em;
                left: 0;
                width: 1.5em;
            }

            .product-box-left .main-image {
                position: relative;
                text-align: center;
            }
            .product-box-left .main-image img {
                max-width: 100%;
            }

            .product-box-left .main-image .product-custom-sticker {
                position: absolute;
                z-index: 10;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                transition: transform 0.2s ease-in-out;
            }

            .product-box-left .main-image .product-custom-sticker img {
                position: absolute;
                object-fit: contain;
                left: 3px;
                z-index: 11;
                bottom: 0;
                max-width: 120px;
                max-height: 120px;
            }

            .choose-gift {
                max-width: 200px;
                margin-top: 20px;
            }

            @media (max-width: 600px) {
                .choose-gift {
                    max-width: 100%;
                    margin-right: 0;
                }

                .product-box-left .main-image img {
                    max-width: 50vw;
                    display: block;
                    margin: auto;
                }
            }

            .product-box-right .colors-list {
                display: grid;
                margin-top: 43px;
                grid-template-columns: repeat(4, 1fr);
                grid-row-gap: 10px;
                max-height: 23rem;
                overflow: hidden;
                overflow-y: hidden;
                overflow-anchor: none;
                overflow-y: scroll;
                touch-action: auto;
                border: 1px solid var(--light-border-color);
                border-radius: 0.5em;
                padding: 0.5em;
            }
            @media (max-width: 400px) {
                .product-box-right .colors-list {
                    grid-template-columns: repeat(3, 1fr);
                }
            }
            @media (max-width: 600px) {
                .product-box-right .colors-list {
                    margin-top: 0;
                }
            }

            .product-box-right .colors-list .color-item {
                text-align: center;
                cursor: pointer;
            }

            .product-box-right .colors-list .color-item .no-image {
                width: 78px;
                height: 78px;
                background: var(--light-border-color);
                border-radius: 50%;
                margin: auto;
                border: 2px solid transparent;
                transition: border-color 0.3s ease-out;
            }

            .product-box-right .colors-list .color-item.cannot-be-bought {
                opacity: 0.3;
            }

            .product-box-right .colors-list .color-item.selected {
                color: var(--color-primary);
            }

            .product-box-right .colors-list .color-item.selected img {
                border-color: var(--color-primary);
            }

            .product-box-right .colors-list .color-item.selected .no-image {
                border-color: var(--color-primary);
            }

            .product-box-right .colors-list .color-item img {
                object-fit: cover;
                width: 78px;
                height: 78px;
                border-radius: 150%;
                margin: auto;
                display: block;
                border: 2px solid transparent;
                transition: border-color 0.3s ease-out;
                box-sizing: border-box;
                padding: 0.5em;
            }

            .product-box-right .colors-list .color-item:hover {
                text-decoration: underline;
            }

            .product-box-right .colors-list .color-name {
                padding-top: 0.3em;
                display: block;
            }

            .product-box-right .show-product {
                margin-top: 20px;
                width: 40%;
                color: rgb(255, 255, 255);
                border-radius: 10px;
                padding: 0.714rem 2rem;
                background-color: var(--color-important-accents);
                text-align: center;
                align-self: center;
                text-decoration: none;
                min-width: 200px;
            }

            .product-box-right div.descriptions {
                max-height: 300px;
                overflow-y: auto;
                overflow-style: inherit;
                max-width: 400px;
            }

            /* Stylowanie paska przewijania */
            .product-box-right div.descriptions::-webkit-scrollbar {
                width: 3px;
            }

            /* Stylowanie tła paska przewijania */
            .product-box-right div.descriptions::-webkit-scrollbar-track {
                background-color: #f1f1f1;
            }

            /* Stylowanie tła paska przewijania */
            .product-box-right div.descriptions::-webkit-scrollbar-thumb {
                background-color: var(--color-primary);
            }

            .product-box-right .sku {
                margin-bottom: 10px;
            }

            .product-box-right .show-product .label {
                text-transform: uppercase;
                font-weight: 600;
            }

            .selected-color span,
            .colors-count b {
                font-weight: 600;
            }

            .cart {
                margin-top: 20px;
            }
            .cart cart-add {
                height: auto;
            }

            .cart cart-add,
            .cart .unavailable {
                width: 100%;
                color: #fff;
                box-sizing: border-box;
                border-radius: 10px;
                display: block;
                border: none;
                padding: 0.714rem 2rem;
                -webkit-transition: all 175ms ease-in 0s;
                transition: all 175ms ease-in 0s;
                background-color: var(--color-important-accents);
            }

            .cart cart-add:hover,
            .product-box-right .show-product:hover {
                background-color: var(--color-important-accents-dark);
            }

            .cart .unavailable {
                background-color: var(--color-important-accents);
                cursor: default;
                opacity: 0.5;
                text-transform: uppercase;
                text-align: center;
                display: flex;
                justify-content: center;
            }

            .cart .unavailable span {
                align-self: center;
            }

            .cart cart-add .cart-add-inner {
                justify-content: space-between;
                display: flex;
                align-items: center;
                height: 100%;
            }

            .cart cart-add .cart-add-inner .price {
                font-weight: 600;
                text-align: left;
            }
            .cart cart-add .cart-add-inner .price > span.sale-price {
                font-size: 1.571rem;
            }
            .cart cart-add .cart-add-inner .price > * {
                white-space: nowrap;
            }

            .cart cart-add .cart-add-inner .price.product-with-dot {
                position: relative;
                margin-right: 40px;
            }

            .cart cart-add .cart-add-inner .price.product-with-dot::after {
                position: absolute;
                display: block;
                content: '';
                border-radius: 50%;
                width: 24px;
                height: 24px;
                background-color: var(--color-primary);
                top: 50%;
                transform: translateY(-50%);
                right: -35px;
            }

            .cart cart-add .cart-add-inner .price .price-per-100 {
                font-size: 0.857rem;
                font-weight: 400;
                display: block;
            }

            .cart cart-add .cart-add-inner .label {
                text-transform: uppercase;
                font-weight: 600;
            }

            .cart cart-add .cart-add-inner del {
                position: relative;
                text-decoration: none;
                font-weight: 400;
                font-size: 0.857rem;
                margin-right: 1em;
            }

            .cart cart-add .cart-add-inner del::after {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                display: inline-block;
                width: 100%;
                -webkit-transform: translate(-50%, -50%) rotate(190deg);
                transform: translate(-50%, -50%) rotate(190deg);
                border-bottom: 1px solid #fff;
            }

            .cart cart-add.prod-as-gift {
                margin-top: 1rem;
                background: #ed8c01 !important;
                color: #fff !important;
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .cart cart-add.prod-as-gift:hover {
                background: #e76801 !important;
            }
        `;
    }
    render() {
        return html ` <div>
            ${this.loading || this.product === null
            ? html `
                      <div class="loading-container">
                          <loader-ring size="20" color="var(--color-primary)"></loader-ring>
                          ${i18n('Loading')}
                      </div>
                  `
            : html `
                      <div
                          class="product-box ${typeof this.product.attributes === 'undefined' ||
                this.product.attributes.length === 0
                ? 'no-colors'
                : ''}"
                      >
                          <div class="product-box-left">
                              <div class="main-image">
                                  ${this.product.product_sticker
                ? html `
                                            <div class="product-custom-sticker">
                                                <img src="${this.product.product_sticker}" />
                                            </div>
                                        `
                : html ``}
                                  <img src="${this.productImageUrl}" />
                              </div>
                              ${this.selectedColor !== null
                ? html `
                                        <p class="selected-color">
                                            ${i18n('Color')}: <span>${this.selectedColor.attribute_name}</span>
                                        </p>
                                    `
                : ''}
                          </div>
                          <div class="product-box-right">
                              <h2>${this.product.name}</h2>
                              <div class="sku">SKU: ${this.product.sku}</div>
                              <div class="descriptions">
                                  ${this.product.descriptions.map((description) => {
                if (description.type !== 'mobile_app_description' &&
                    description.type !== 'mobile_app_ingredients') {
                    return;
                }
                const p = document.createElement('p');
                p.classList.add('description');
                p.classList.add(description.type);
                p.innerHTML = description.html; // Wstawiamy tekst zamiast HTML
                return p;
            })}
                              </div>
                              ${typeof this.product.attributes !== 'undefined' && this.product.attributes.length > 0
                ? html `
                                        <span class="colors-count">
                                            ${i18n('Available colors')}
                                            <b>${this.product.attributes.length}</b>
                                        </span>
                                    `
                : ''}
                              ${typeof this.product.attributes !== 'undefined' &&
                this.product.attributes.length > 0 &&
                !this.fromCart
                ? html `
                                        <div class="colors-list">
                                            ${this.product.attributes.map((color, index) => {
                    if (this.product === null) {
                        return '';
                    }
                    return html `
                                                    <div
                                                        class="color-item ${color.sku === this.sku
                        ? 'selected'
                        : ''} ${!color.active ? 'disabled' : ''} ${!color
                        .availability.can_be_bought
                        ? 'cannot-be-bought'
                        : ''}"
                                                        @click=${() => {
                        if (color.active) {
                            this.changeColor(color, index);
                        }
                    }}
                                                    >
                                                        ${this.colorImage(color)}
                                                        <span class="color-name">${color.attribute_name}</span>
                                                    </div>
                                                `;
                })}
                                        </div>
                                    `
                : ''}
                              ${typeof this.product.attributes === 'undefined' ||
                (this.product.attributes.length === 0 && !this.fromCart)
                ? html ` <div></div>`
                : ''}
                              ${this.activeStore && this.product.flags.gift === false && !this.fromCart
                ? html `
                                        <div class="cart">
                                            ${this.productAvailable
                    ? html `
                        <cart-add sku="${this.sku}" productID="${this.productID}" altshopID="${this.altshopID}" @click="${this._cartAdd}">
                            <div class="cart-add-inner">
                                <div class="${this.product.flags.green_point ? 'product-with-dot' : ''} price">
                                    ${this.product.price != this.product.catalog_price
                        ? html `
                                                  <span class="sale-price"
                                                      >${this.product.price.toFixed(this.decimalDigits)}
                                                      ${this.currency}</span
                                                  >
                                              `
                        : html `
                                                  <span class="sale-price"
                                                      >${this.product.catalog_price.toFixed(this.decimalDigits)}
                                                      ${this.currency}</span
                                                  >
                                              `}
                                    ${this.product.price != this.product.catalog_price
                        ? html `
                                                  <del
                                                      >${this.product.catalog_price.toFixed(this.decimalDigits)}
                                                      ${this.currency}</del
                                                  >
                                              `
                        : ''}
                                    ${this.product.price_per_unit !== null
                        ? html ` <span class="price-per-100"
                                                  >${this.product.price_per_unit.unit}:
                                                  ${formatPrice(this.product.price_per_unit.price)}</span
                                              >`
                        : ''}
                                </div>
                                <div class="label">
                                    ${i18n('Add to cart')}
                                </div>
                            </div>
                        </cart-add>
                    </div>
                    ${this.showProdAsGiftButton
                        ? html `
                                  <div class="cart">
                                      <cart-add
                                          class="prod-as-gift"
                                          sku="${this.sku}"
                                          productID="${this.productID}"
                                          altshopID="${this.altshopID}"
                                          productAsGift
                                          @click="${this._cartAdd}"
                                      >
                                          <span>${this.prodAsGiftButtonText}</span>
                                      </cart-add>
                                  </div>
                              `
                        : ''}
                `
                    : html `
                                                      <div class="unavailable">
                                                          <span>${i18n('product unavailable')}</span>
                                                      </div>
                                                      ${this.webpushEnabled
                        ? html `
                                                                <webpush-button
                                                                    subscribeText="${i18n('Notify me when product is available')}"
                                                                    subscribedText="${i18n('You will be notified when product is available')}"
                                                                    subscriptionType="2"
                                                                    subscriptionDetails="${JSON.stringify({
                            SKU: this.sku,
                        })}"
                                                                ></webpush-button>
                                                            `
                        : ''}
                                                  `}
                                        </div>
                                    `
                : ''}
                          </div>
                      </div>
                  `}
        </div>`;
    }
    connectedCallback() {
        super.connectedCallback();
        if (typeof window.__STATE__ !== 'undefined') {
            this.currency = window.__STATE__.localization.currency;
            this.decimalDigits = window.__STATE__.localization.decimal_digits;
        }
        fetch('/api/catalog/product', {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify({ id: this.productID, altshop_id: this.altshopID }),
        })
            .then((response) => {
            if (response.ok === false) {
                throw new Error('Unknown failure');
            }
            return response;
        })
            .then((response) => response.json())
            .then((productData) => {
            this.loading = false;
            this.product = productData;
            Cart.getPromotionForSKU(this.product.sku)
                .then((promotions) => {
                promotions.forEach((promotion) => {
                    promotion.actions.forEach((action) => {
                        if (action.type === 'product_as_gift') {
                            this.prodAsGiftButtonText = action.settings.button_text;
                            this.showProdAsGiftButton = true;
                        }
                    });
                });
            })
                .catch((err) => {
                console.error('Failed to get promotions for product_as_gift promotion check', err);
            });
        })
            .catch((err) => {
            console.error('Failed to fetch product that was requested for product-modal', err);
        });
    }
    _cartAdd() {
        this.dispatchEvent(new CustomEvent('product-modal-cart-add', {
            detail: {
                product: this.product,
                sku: this.sku,
                color: this.selectedColor,
            },
            composed: true,
            bubbles: true,
        }));
    }
    /**
     * Pobierz URL głównego obrazka produktu lub aktualnie wybranego koloru
     */
    get productImageUrl() {
        if (this.product === null) {
            return '';
        }
        let imageUrl = '';
        // Jeżeli wybrano kolor to prezentujemy zdjęcie koloru
        if (this.selectedColor !== null) {
            this.selectedColor.images.forEach((img) => {
                if (img.type === 'main') {
                    img.sizes.forEach((size) => {
                        if (size.size === '500x500') {
                            imageUrl = size.url;
                        }
                    });
                }
            });
        }
        // Falback/default: obrazek produktu
        if (imageUrl === '') {
            this.product.main_image.sizes.forEach((size) => {
                if (size.size === '500x500') {
                    imageUrl = size.url;
                }
            });
        }
        return imageUrl;
    }
    /**
     * Pobierz aktualnie wybrany kolor (jeżeli produkt ma kolory)
     */
    get selectedColor() {
        if (this.product === null || typeof this.product.attributes === 'undefined') {
            return null;
        }
        let attr = null;
        this.product.attributes.forEach((attribute) => {
            if (attribute.sku === this.sku) {
                attr = attribute;
            }
        });
        return attr;
    }
    get activeStore() {
        if (typeof window.__STATE__ !== 'undefined') {
            return window.__STATE__.functions.active_store;
        }
        return false;
    }
    get reviewsEnabled() {
        if (typeof window.__STATE__ !== 'undefined') {
            return window.__STATE__.functions.reviews;
        }
        return false;
    }
    get productAvailable() {
        if (this.product === null) {
            return false;
        }
        const selectedColor = this.selectedColor;
        if (selectedColor === null) {
            // Produkt bez kolorów
            return this.product.availability.can_be_bought;
        }
        return selectedColor.availability.can_be_bought;
    }
    get discountPercentage() {
        if (this.product === null || this.product.price === this.product.catalog_price) {
            return '0';
        }
        return Math.ceil(100 - (this.product.price / this.product.catalog_price) * 100).toFixed(0);
    }
    get webpushEnabled() {
        return typeof window.__WEBPUSH__ !== 'undefined';
    }
    /**
     * Zmień aktualnie wybrany kolor produktu
     */
    changeColor(color, index) {
        this.sku = color.sku;
        const event = new CustomEvent('changeColor', {
            detail: {
                sku: this.sku,
                color: this.selectedColor,
                index: index,
            },
            bubbles: true,
            composed: true,
        });
        this.dispatchEvent(event);
    }
    /**
     * Pobierz kod HTML małego obrazka koloru
     */
    colorImage(color) {
        let previewImg = null;
        color.images.forEach((img) => {
            if (img.type === 'color' && typeof img.sizes[0] !== 'undefined') {
                previewImg = img.sizes[0].url;
            }
        });
        if (previewImg === null) {
            return html `<div class="no-image"></div>`;
        }
        return html `<img .src=${previewImg} draggable="false" />`;
    }
};
__decorate([
    property({ type: String })
], ProductModal.prototype, "sku", void 0);
__decorate([
    property({ type: String })
], ProductModal.prototype, "productID", void 0);
__decorate([
    property({ type: Object })
], ProductModal.prototype, "product", void 0);
__decorate([
    property({ type: Boolean })
], ProductModal.prototype, "loading", void 0);
__decorate([
    property({ type: String })
], ProductModal.prototype, "currency", void 0);
__decorate([
    property({ type: String })
], ProductModal.prototype, "prodAsGiftButtonText", void 0);
__decorate([
    property({ type: Boolean })
], ProductModal.prototype, "showProdAsGiftButton", void 0);
__decorate([
    property({ type: Number })
], ProductModal.prototype, "decimalDigits", void 0);
__decorate([
    property({ type: String })
], ProductModal.prototype, "altshopID", void 0);
__decorate([
    property({ type: Boolean })
], ProductModal.prototype, "fromCart", void 0);
ProductModal = __decorate([
    customElement('product-modal')
], ProductModal);
export default ProductModal;
